import { Component, inject } from '@angular/core';
import { DashboardAppShellFacade } from './facades/dashboard-app-shell.facade';

@Component({
	standalone: false,
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	providers: [DashboardAppShellFacade],
})
export class AppComponent {
	readonly title = 'Dashboard';

	constructor() {
		inject(DashboardAppShellFacade);
	}
}
